export default {
    // 和牧同兴
    // appid: 'wxd17e4e424e2f35b8',
    // 秉牧饲料
    appid: 'wx6a410446a763f018',
    // 身份验证
    token: sessionStorage.getItem('token') || null,
    // 企业信息
    enterpriseInfo: sessionStorage.getItem('enterpriseInfo')
        ? JSON.parse(sessionStorage.getItem('enterpriseInfo'))
        : null,
    // 用户信息
    userInfo: sessionStorage.getItem('userInfo') ? JSON.parse(sessionStorage.getItem('userInfo')) : null,
    // 客户信息
    customerInfo: {
        // 客户跟进流程
        process: ['初步沟通', '深入交流', '物流查货', '售后服务', '活动通知', '无效客户'],
        state: [
            {
                key: '无人接听',
                value: '暂时无人接听，稍后再拨'
            },
            {
                key: '挂电话',
                value: '客户挂断电话'
            },
            {
                key: '申请加微',
                value: '已申请加微信'
            },
            {
                key: '已加微信',
                value: '已加微信，再聊'
            },
            {
                key: '空号',
                value: '拨打的电话是空号'
            },
            {
                key: '占线',
                value: '拨打的电话正在通话中，稍后再拨'
            }
        ]
    },
    // 订单流程信息
    orderInfo: {
        list: [
            {
                key: 0,
                value: '新订单'
            },
            {
                key: 1,
                value: '已下单'
            },
            {
                key: 2,
                value: '备货中'
            },
            {
                key: 3,
                value: '申请取消'
            },
            {
                key: 30,
                value: '已取消'
            },
            {
                key: 4,
                value: '配送中'
            },
            {
                key: 40,
                value: '已签收'
            },
            {
                key: 41,
                value: '申请退货'
            },
            {
                key: 410,
                value: '已退货'
            }
        ],
        memo: [
            {
                key: '代收（元）',
                value: '代收（元）'
            },
            {
                key: '不发桶',
                value: '不发桶'
            },
            {
                key: '听通知放货',
                value: '听通知放货'
            },
            {
                key: '送货',
                value: '送货'
            },
            {
                key: '补发',
                value: '补发'
            },
            {
                key: '赠品',
                value: '赠品'
            }
        ]
    },
    econciliationInfo: {
        list: [
            {
                key: 0,
                value: '待对账'
            },
            {
                key: 1,
                value: '对账完成'
            }
        ]
    },
    // 支付渠道信息
    payInfo: {
        list: [
            {
                key: 11,
                value: '微信',
                label: '快捷支付'
            },
            {
                key: 12,
                value: '支付宝',
                label: '快捷支付'
            },
            {
                key: 21,
                value: '赤乐川牛羊饲料官方店',
                label: '淘宝'
            },
            {
                key: 211,
                value: 'ghj490810897企业店',
                label: '淘宝'
            },
            {
                key: 214,
                value: '赤乐川饲料品牌店',
                label: '淘宝'
            },
            {
                key: 22,
                value: '赤乐川饲料官方旗舰店',
                label: '公司拼多多'
            },
            {
                key: 221,
                value: '赤乐川牛羊饲料瘤胃宝',
                label: '石家庄拼多多'
            },
            {
                key: 222,
                value: '赤乐川牛羊饲料脱霉剂',
                label: '石家庄拼多多'
            },
            {
                key: 223,
                value: '赤乐川牛羊预混料企业店铺',
                label: '大厂拼多多'
            },
            {
                key: 224,
                value: '通州其他店',
                label: '拼多多'
            },
            {
                key: 225,
                value: '石家庄其他店',
                label: '拼多多'
            },
            {
                key: 23,
                value: '赤乐川官方旗舰店',
                label: '微信小商店'
            },
            {
                key: 24,
                value: '赤乐川牛羊饲料商城',
                label: '微店'
            },
            {
                key: 25,
                value: '赤乐川牛羊饲料官方号',
                label: '快手'
            },
            {
                key: 26,
                value: '赤乐川牛羊饲料店',
                label: '抖音'
            },
            {
                key: 31,
                value: '中国农业银行',
                label: '对公账户'
            },
            {
                key: 32,
                value: '中国农业银行',
                label: '个人账户'
            },
            {
                key: 33,
                value: '中国邮政储蓄银行',
                label: '个人账户'
            },
            {
                key: 34,
                value: '北京农商银行',
                label: '个人账户'
            },
            {
                key: 35,
                value: '企业商户号',
                label: '对公账户'
            },
            {
                key: 51,
                value: '其他方式',
                label: '备注'
            }
        ]
    },
    // 发货方式
    deliverInfo: {
        list: [
            {
                key: 1,
                value: '立即发货'
            },
            {
                key: 2,
                value: '延迟发货'
            }
        ]
    },
    // 物流方式
    expressInfo: {
        list: [
            {
                label: '物流',
                options: [
                    {
                        key: 12,
                        value: '天津物流',
                        label: '物流',
                        meta: {
                            style: 'color: #d7000f',
                            exclude: {
                                product: [16, 27, 38, 46],
                                unit: [3, 4, 5, 6, 7]
                            }
                            // 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39
                        }
                    },
                    {
                        key: 13,
                        value: '专线物流',
                        label: '物流',
                        meta: {
                            style: '',
                            exclude: {
                                product: [16, 27, 35, 36, 37, 38, 39],
                                unit: [3, 4, 5, 6, 7]
                            }
                        }
                    }
                ]
            },
            {
                label: '快递',
                options: [
                    {
                        key: 11,
                        value: '天津德邦',
                        label: '快递',
                        meta: {
                            style: 'color: #003c8d',
                            exclude: {
                                product: [
                                    14,
                                    15,
                                    18,
                                    19,
                                    21,
                                    22,
                                    23,
                                    24,
                                    25,
                                    26,
                                    27,
                                    28,
                                    29,
                                    30,
                                    31,
                                    32,
                                    33,
                                    34,
                                    35,
                                    36,
                                    37,
                                    38,
                                    39
                                ],
                                unit: [3, 5, 6, 7]
                            }
                        }
                    },
                    {
                        key: 21,
                        value: '河北德邦',
                        label: '快递',
                        meta: {
                            style: 'color: #003c8d',
                            product: [
                                3,
                                4,
                                5,
                                7,
                                8,
                                9,
                                10,
                                11,
                                12,
                                13,
                                14,
                                15,
                                16,
                                18,
                                19,
                                20,
                                21,
                                22,
                                23,
                                24,
                                25,
                                26,
                                27,
                                28,
                                29,
                                30,
                                31,
                                32,
                                33,
                                34,
                                38
                            ],
                            unit: [3, 5, 6, 7]
                        }
                    },
                    {
                        key: 22,
                        value: '河北圆通',
                        label: '快递',
                        meta: {
                            style: 'color: #47086c',
                            exclude: {
                                product: [14, 15, 18, 19, 28, 29, 30, 31, 32, 33, 34],
                                unit: [1, 2, 4]
                            }
                        }
                        // }, {
                        //     'key': 23,
                        //     'value': '河北百世',
                        //     'label': '快递'
                    }
                ]
            },
            {
                label: '其他',
                options: [
                    {
                        key: 31,
                        value: '经销商发货',
                        label: '其他',
                        meta: {
                            style: '',
                            exclude: {
                                product: [],
                                unit: [3, 4, 6, 7]
                            }
                        }
                    },
                    {
                        key: 32,
                        value: '其他方式',
                        label: '其他',
                        meta: {
                            style: '',
                            exclude: {
                                product: [],
                                unit: [3, 4, 6, 7]
                            }
                        }
                    }
                ]
            }
        ]
    }
}
